import React, { useContext, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import StarProfileRightContent from "./StarCardComponent/StarProfileRightContent/StarProfileRightContent";

import axios from "axios";
import { Markup } from "interweave";
import { Link } from "react-router-dom";
import noImage from "../../Assets/Images/settings/no-image.png";
import ContentLoader from "../../Screen/ContentLoader";
import NodataAvailable from "../Common/NodataAvailable";
import { serverInfo } from "../../App";
import { LocationContext } from "../../CustomHelper/Helper";
const StarMarketPlace = ({ star_id }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [starMarketplace, setStarMarketplace] = useState([]);
  const { slectedCurrency } = useContext(LocationContext);
  
  const handelCuntrybasePrice = (fee) => {
    return (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0);
  };
  

  useEffect(() => {
    axios.get(`/api/user/marketplace/all/${star_id}`).then((res) => {
      if (res.data.status === 200) {
        setStarMarketplace(res.data.starMarketplace);
      }
    });
  }, []);

  return (
    <div className="container StarContainer">
      <div className="row">
        <div className="col-sm-12 col-lg-8 mt-2">
          {starMarketplace.length === 0 ? (
            <NodataAvailable className="mt-5" />
          ) : null}

          {starMarketplace?.map((marketplace, index) => (
            <div className="bg-adrk p-3 card m-3 mb-4 AuctionsA  ">
              <div className=" row TabMar">
                <div className="col-md-6">
                  <OwlCarousel
                    items={1}
                    loop
                    autoplay
                    autoplayTimeout={3000}
                    margin={0}
                    dots={false}
                  >
                    <img
                      src={
                        marketplace?.image
                          ? imageCdnUrl + marketplace?.image
                          : noImage
                      }
                      alt=""
                      className="img-fluid AuctionsImg "
                    />
                  </OwlCarousel>
                </div>

                <div className="col-md-6 containerAuc px-3">
                  <div className="w-100">
                    <h3> {marketplace.title}</h3>
                    <p className="text-light ">
                      <Markup
                        content={marketplace.description.substring(0, 100)}
                      ></Markup>
                    </p>

                    <div className="text-light ">
                      <span className="DollarPrice fw-bold">
                      
                      {handelCuntrybasePrice(marketplace?.unit_price) +
                      " " +
                      slectedCurrency?.symbol}
                      </span>
                      &nbsp;
                    </div>
                    <div className="d-flex mt-2 JerseyAucPro w-100">
                      <img
                        src={
                          marketplace.superstar?.image
                            ? imageCdnUrl + marketplace.superstar?.image
                            : noImage
                        }
                        className="AuctionProImg img-fluid"
                        alt="star-profile"
                      />
                      <span className="mx-2 mt-1 SpanAu">
                        <small className="proTextSm fw-bold">Superstar</small>
                        <div className="proTextAc">
                          {marketplace?.superstar?.first_name}{" "}
                          {marketplace?.superstar?.last_name}
                        </div>
                      </span>
                    </div>

                    <Link to={`/marketplace/shipping/${marketplace?.slug}`}>
                      <button className="btn bg-warning mt-2  fw-bold w-100 JerseyAucBuy">
                        {" "}
                        Buy Now
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="col-md-4">
          <StarProfileRightContent star_id={star_id} />
        </div>
      </div>
    </div>
  );
};

export default StarMarketPlace;
